import script from "./VendorDetail012.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorDetail012.vue?vue&type=script&setup=true&lang=js"

import "./VendorDetail012.vue?vue&type=style&index=0&id=c10405ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c10405ca"]])

export default __exports__